import { renderChildren } from '@/components/Menu/MenuUtil';
import { noop } from '@/utils/util';
import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './Menu.scss';

class Menu extends Component {
  static defaultProps = {
    onClick: noop,
    onMouseLeave: noop,
  };

  onMouseLeave = (e) => {
    const { onMouseLeave } = this.props;
    onMouseLeave(e);
  };

  render() {
    const {
      show,
      children,
      className,
      onClick,
      getMenuDom,
    } = this.props;
    return (
      <ul ref={getMenuDom} className={classNames(className, styles['menu'])} onMouseLeave={this.onMouseLeave}>
        {
          renderChildren(children, {
            onClick,
          })
        }
      </ul>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js